import React, { Component, Fragment } from 'react';
import './App.css';
import HomeData from './HomeData';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import TermsOfUse from './components/TermsOfUse/TermsOfUse';
import ShippingPolicy from './components/ShippingPolicy';
import { BrowserRouter as Router, Route } from "react-router-dom";
import '../node_modules/react-owl-carousel2/src/owl.carousel.css';
import '../node_modules/react-owl-carousel2/src/owl.theme.default.css';

class App extends Component {
  render() {
    return (
      <Router>
        <Fragment>
          <Route path="/" exact component={HomeData} />
          <Route path="/privacypolicy" exact component={PrivacyPolicy} />
          <Route path="/termsofuse" exact component={TermsOfUse} />
          <Route path="/shippingpolicy" exact component={ShippingPolicy} />
        </Fragment>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js